import React, { Fragment } from "react";
import { Row, Col, Button, Label, Collapse, FormGroup } from "reactstrap";

import chroma from "chroma-js";
import Select from "react-select";
import SearchDate from "./SearchDate";

const StatusOptions = [
  { value: 0, label: "SELECT", color: "#b3b3b3", isFixed: true },
  { value: 1, label: "PASS", color: "#29a329" },
  { value: 2, label: "FAIL", color: "#cc0000" }
];
/*********************************** STYLE SELECT ***********************************/
const dot = (color = "#ccc") => ({
  alignItems: "center",
  display: "flex",

  ":before": {
    backgroundColor: color,
    borderRadius: 10,
    content: '" "',
    display: "block",
    marginRight: 8,
    height: 10,
    width: 10
  }
});
const colourStyles = {
  control: styles => ({
    ...styles,
    backgroundColor: "white"
  }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    const color = chroma(data.color);
    return {
      ...styles,
      backgroundColor: isDisabled
        ? null
        : isSelected
        ? data.color
        : isFocused
        ? color.alpha(0.1).css()
        : null,
      color: isDisabled
        ? "#ccc"
        : isSelected
        ? chroma.contrast(color, "white") > 2
          ? "white"
          : "black"
        : data.color,
      fontWeight: "bold",
      cursor: isDisabled ? "not-allowed" : "default"
    };
  },
  input: styles => ({
    ...styles,
    ...dot()
  }),
  placeholder: styles => ({
    ...styles,
    ...dot()
  }),
  singleValue: (styles, { data }) => ({
    ...styles,
    ...dot(data.color)
  })
};
export default class SearchBar extends React.Component {
  constructor(props) {
    super();
    this.state = {
      showAdvancedOptions: false,
      selectedStatusOpt: null,
      status: "",
      startDate: Date,
      endDate: Date
    };
  }

  /*********************************** LIFECYCLE ***********************************/
  async componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }
  handleAdvancedOptions = () => {
    const newShowAdvancedOptions = !this.state.showAdvancedOptions;
    this.setState({ showAdvancedOptions: newShowAdvancedOptions }, () => {
      this.props.handleAdvancedOpt({ newShowAdvancedOptions });
    });
  };

  handleChangeData = ({ startDate, endDate }) => {
    this.setState({ startDate, endDate }, () =>
      this.props.handleChange({
        startDate,
        endDate
      })
    );
  };

  handleValueSelected = value => {
    const selectedValue = value.label;
    this.setState(
      {
        selectedStatusOpt: value,
        status: selectedValue
      },
      () => this.props.handleStatus({ selectedValue })
    );
  };
  /*********************************** RENDER ***********************************/
  render() {
    const { selectedStatusOpt } = this.state;
    return (
      <Fragment>
        <div
          className="col-sm-12"
          style={{
            display: "inline-block",
            backgroundColor: "#eeeeee",
            cursor: "pointer"
          }}
          onClick={this.handleAdvancedOptions}
        >
          <h6
            style={{
              display: "inline-block",
              paddingLeft: "20px",
              paddingTop: "20px",
              paddingBottom: "7px"
            }}
          >
            Advanced Options:
          </h6>
          <i
            className={
              this.state.showAdvancedOptions
                ? "lnr-chevron-up-circle"
                : "lnr-chevron-down-circle"
            }
            style={{
              fontSize: "20px",
              marginTop: "19px",
              marginRight: "14px",
              float: "right"
            }}
          >
            {" "}
          </i>
        </div>
        <Collapse isOpen={this.state.showAdvancedOptions}>
          <Row
            className="mb-2"
            style={{
              paddingTop: "14px"
            }}
          >
            <div
              className="col-sm-4"
              style={{
                paddingLeft: "34px",
                paddingRight: "0px"
              }}
            >
              <SearchDate handleChangeData={this.handleChangeData} />
            </div>
            <div
              className="col-sm-8"
              style={{
                paddingRight: "40px"
              }}
            >
              <Col
                sm="12"
                md="4"
                xl="4"
                style={{
                  display: "inline-block"
                }}
              >
                <FormGroup>
                  <Label
                    className="mr-sm-2"
                    style={{
                      display: "block",
                      textAlign: "center"
                    }}
                  >
                    Status
                  </Label>

                  <Select
                    name="selectedStatus"
                    styles={colourStyles}
                    value={
                      selectedStatusOpt ? selectedStatusOpt : StatusOptions[0]
                    }
                    onChange={this.handleValueSelected}
                    options={StatusOptions}
                  />
                </FormGroup>
              </Col>
              <Col
                sm="12"
                md="3"
                xl="3"
                style={{
                  display: "inline-block",
                  position: "relative",
                  paddindLeft: "20px"
                }}
              >
                <Button
                  color="info"
                  className="btn-pill btn-shadow btn-wide fsize-1 col-sm-12"
                  size="lg"
                  style={{
                    position: "absolute",
                    bottom: "-13px",
                    width: "calc(100% - 20px)"
                  }}
                  onClick={this.props.refreshTable}
                >
                  <span>Filter</span>
                </Button>
              </Col>
            </div>
          </Row>
          <div
            style={{
              width: "100%",
              height: "4px",
              backgroundColor: "#E3E6EE"
            }}
          />
        </Collapse>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/Search/SearchBar.js